import API from './api.js'

export default {
    async getSamples(folderId) {
        try {
            let response = await API.HTTPS.get('/folders/' + folderId + '/samples?page=1&pagesize=10000')

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    }
}